import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { ThumbsDown, ThumbsUp } from 'lucide-react';
import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
export const FeedbackMessage = ({ clicked, handleClick }) => {
    const { t } = useTranslation();
    const [hoveredButton, setHoveredButton] = useState(null);
    const timeoutRef = useRef();
    const handleMouseEnter = (value) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setHoveredButton(value);
    };
    const handleMouseLeave = () => {
        timeoutRef.current = setTimeout(() => {
            setHoveredButton(null);
        }, 300);
    };
    const getMessage = () => {
        if (hoveredButton === 1 || clicked === 1) {
            return t('feedback.helpful_button');
        }
        return t('feedback.not_helpful_button');
    };
    const classNames = {
        button: 'hover:bg-highlight-background cursor-pointer rounded-md p-0.5 transition-all duration-200',
        clicked: 'bg-highlight-background',
    };
    return (_jsxs("div", { className: "animate-fade-in mt-2 flex items-center gap-4 opacity-0 delay-500 [animation-fill-mode:forwards]", children: [_jsxs("div", { className: "flex items-center gap-4", children: [_jsx("button", { onClick: () => handleClick(1), onMouseEnter: () => handleMouseEnter(1), onMouseLeave: handleMouseLeave, className: cn(classNames.button, {
                            [classNames.clicked]: clicked === 1,
                        }), children: _jsx(ThumbsUp, { size: 18, className: "text-accent" }) }), _jsx("button", { onClick: () => handleClick(-1), onMouseEnter: () => handleMouseEnter(-1), onMouseLeave: handleMouseLeave, className: cn(classNames.button, {
                            [classNames.clicked]: clicked === -1,
                        }), children: _jsx(ThumbsDown, { size: 18, className: "text-accent" }) })] }), _jsx("span", { className: cn('text-accent text-xs transition-all duration-200', hoveredButton || clicked ? 'opacity-100' : 'opacity-0'), children: getMessage() })] }));
};
